import { render, staticRenderFns } from "./best_tce.vue?vue&type=template&id=4402f6ea&"
import script from "./best_tce.vue?vue&type=script&lang=js&"
export * from "./best_tce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports